import {Separator} from 'platform/components';

import i18n from '@dms/i18n';
import {usePermissions} from '@dms/shared';

import {VehicleForm as VFKit} from '../../kit/VehicleForm';

export function FeatureSelectorSubSection() {
  const [canReadBusinessCase] = usePermissions({permissionKeys: ['businessCaseRead']});

  return (
    <VFKit.SubSection data-testid="features-selector" title={i18n.t('general.labels.allFeatures')}>
      <VFKit.ShowWhen when={canReadBusinessCase}>
        <VFKit.FeatureSelector />
      </VFKit.ShowWhen>

      <Separator spacing={2} />

      <VFKit.FeaturesByManufacturerTextarea />
    </VFKit.SubSection>
  );
}
